export const VEHICLE_TABS = [
	{ id: "dados", label: "Dados do veículo", isDisabled: false },
	{ id: "hodometro", label: "Hodômetro", isDisabled: false },
	{ id: "documentos", label: "Documentos", isDisabled: false },
	{ id: "expediente", label: "Expediente", isDisabled: false },
	{ id: "telemetria", label: "Telemetria", isDisabled: false },
];

export const DOCUMENTOS_SUB_TABS = [
	{ id: "principais", label: "Principais", isDisabled: false },
	{ id: "outros", label: "Outros", isDisabled: false },
];
